export const INITIALS_PLACEHOLDER = 'UK';

export const parseInitials = (fullName: string): string =>
	fullName
		?.match(/(\b\S)?/g)
		?.join('')
		.toUpperCase() || INITIALS_PLACEHOLDER;

export const formatNumber = (number: number) => new Intl.NumberFormat('en-UK').format(number);
